import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useEffect, useState } from 'react';
export var VIEWPORTS = {
  DESKTOP: 1087
};
export var DimensionsContext = createContext({});
var Provider = DimensionsContext.Provider;
export var DimensionsProvider = function DimensionsProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setMobile = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isCrawler = _useState4[0],
      setCrawler = _useState4[1];

  useEffect(function () {
    var listener = function listener() {
      return setMobile(window.innerWidth < VIEWPORTS.DESKTOP);
    };

    listener();
    setCrawler(false);
    window.addEventListener('resize', listener);
    return function () {
      return window.removeEventListener('resize', listener);
    };
  }, []);
  return React.createElement(Provider, {
    value: {
      isMobile: isMobile,
      isCrawler: isCrawler
    }
  }, children);
};